<template>
<div></div>
</template>

<script>
export default {
    name: 'Callback',

    mounted() {
        this.$store.dispatch('oauth2/authenticate', {
            code: this.$route.query.code,
            state: this.$route.query.state
        }).then(() => {
            window.location.href = '/dashboard'
        }).catch(() => {
            window.location.href = process.env.VUE_APP_BASE_OAUTH2+'/login'
        })
    }
}
</script>